export const storeName = 'modiface';

export const constants = {
    CHOICE_MODE: 'CHOICE_MODE',
    PHOTO_MODE: 'PHOTO_MODE',
    LIVE_MODE: 'LIVE_MODE',
};
